if (!customElements.get('product-groups-async')) {
  class ProductGroupsAsync extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) {
        this.remove();
        return;
      }
      const cacheKey = `product-groups:${url}`;
      let cached = null;
      try {
        cached = sessionStorage.getItem(cacheKey);
      } catch (error) {
        cached = null;
      }
      if (cached !== null) {
        this.render(cached);
        return;
      }
      fetch(url)
        .then(response => (response.ok ? response.text() : ''))
        .then(text => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const groups = html.querySelector('.product__product-groups');
          const markup = groups ? groups.outerHTML : '';
          try {
            sessionStorage.setItem(cacheKey, markup);
          } catch (error) {
            // storage pieno o non disponibile: si va avanti senza cache
          }
          this.render(markup);
        })
        .catch(() => this.remove());
    }

    render(markup) {
      if (!markup) {
        this.remove();
        return;
      }
      const template = document.createElement('template');
      template.innerHTML = markup;
      const groups = template.content.firstElementChild;
      if (groups) {
        this.replaceWith(groups);
      } else {
        this.remove();
      }
    }
  }
  customElements.define('product-groups-async', ProductGroupsAsync);
}
